import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { fixedAssetIncreDecreTotalTableReportTypeClassConfig } from './FixedAssetIncreDecreTotalTableReportType.name';

/** 固定資産増減合計表の帳票種類ENUM */
enum FixedAssetIncreDecreTotalTableReportType {
  /**固定資産増減合計表 */
  fixedAssetIncreDecreTotalTable = '1',
  /**固定資産増減合計表(詳細) */
  fixedAssetIncreDecreTotalTableDetails = '2',
}

const fixedAssetIncreDecreTotalTableReportTypeMap = new Map([
  ['1', FixedAssetIncreDecreTotalTableReportType.fixedAssetIncreDecreTotalTable],
  ['2', FixedAssetIncreDecreTotalTableReportType.fixedAssetIncreDecreTotalTableDetails],
]);

const rawValueToFixedAssetIncreDecreTotalTableReportType = rawValueToEnumWithDefault(
  fixedAssetIncreDecreTotalTableReportTypeMap,
  FixedAssetIncreDecreTotalTableReportType.fixedAssetIncreDecreTotalTable,
);

const fixedAssetIncreDecreTotalTableReportTypeToDisplay = enumToNameWithDefault(
  FixedAssetIncreDecreTotalTableReportType,
  fixedAssetIncreDecreTotalTableReportTypeClassConfig,
);

const fixedAssetIncreDecreTotalTableReportTypeToDisplayWithPrefix = enumToNameWithDefault(
  FixedAssetIncreDecreTotalTableReportType,
  fixedAssetIncreDecreTotalTableReportTypeClassConfig,
  true,
);

export {
  FixedAssetIncreDecreTotalTableReportType,
  fixedAssetIncreDecreTotalTableReportTypeToDisplay,
  fixedAssetIncreDecreTotalTableReportTypeToDisplayWithPrefix,
  rawValueToFixedAssetIncreDecreTotalTableReportType,
};
